const addDataAttributeToCTACard = () => {   
    const ctaCards = document.querySelectorAll('.is-style-cta-price-card-hover') ?? [];
    const blueIconBackground = '--feb-icon-background-color: #72D8DE';
    const neonIconBackground = '--feb-icon-background-color: #E9FD08';
    
    // if no CTA cards exist, exit here
    if (!ctaCards) {
        return;
    } 
    
    // if CTA cards exist, do the following for each card
    else {
        ctaCards.forEach((card) => {
            const icon = card.querySelector('.feb__icon-block') ?? '';

            // if no icon exists, exit here
            if (!icon) {
                return;
            } 
            
            else {
                // if the icon has a blue background, assign it an attribute of 'blue'
                if (icon.getAttribute('style') && icon.getAttribute('style').includes(blueIconBackground)) {
                    icon.setAttribute('data-bg-color', 'blue');
                } 
                
                // if the icon has a neon background, assign it an attribute of 'neon'
                else if (icon.getAttribute('style') && icon.getAttribute('style').includes(neonIconBackground)) {
                    icon.setAttribute('data-bg-color', 'neon');
                } 
                
                // otherwise, exit here
                else {
                    return;
                }
            }
            
        });
    }  
};

export default addDataAttributeToCTACard;